import * as yup from "yup";

export const ArchivoSchema = yup.object().shape({
  id: yup.string().optional().default(""),
  URL: yup.string().url("errors.archivo.URL.format").default(""),
  nombre: yup.string().required("errors.archivo.nombre.required").default(""),
  tipoMIME: yup
    .string()
    .required("errors.archivo.tipoMIME.required")
    .default(""),
  chequeo: yup.string().required("errors.archivo.chequeo.required").default(""),
  bytes: yup.string().optional().default(""),
});
